import React, { useCallback, useEffect, useState, useRef } from 'react';
import { notification, Button, message, Tooltip, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import Icon, {
    FileExcelOutlined,
    LoadingOutlined
} from '@ant-design/icons';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';

import { VerificaRota } from '../../../../services/VerificaSePodeAcessar';
import { EmitirErro } from '../../../../services/EmitirErro';
import { SairDoSistema } from '../../../../services/LStorage/SairSistema';

import { convertDataUSParaBrasilEHora } from '../../../../services/Conversores';

import { useGetColumnSearchProps } from '../../../../hooks/FilterTable/string';
import { useGetColumnSearchPropsData } from '../../../../hooks/FilterTable/date';

import { RcFile } from 'antd/lib/upload';
import { UploadChangeParam } from 'antd/es/upload/interface';
import { UploadFile } from 'antd/lib/upload/interface';
import { useGetColumnSearchPropsObj } from '../../../../hooks/FilterTable/objString';
import CongelamentoEmLoteService from '../../../../services/http/services/CongelamentoPorCNPJ/CongelamentoEmLoteService';
import { ICongelamentoEmLote } from './interface';
import { io } from 'socket.io-client';
import { urlHttpGovSocketIo } from '../../../../services/urls';

const IconDownload = (props: any) => <Icon {...props} component={FaDownload} ></Icon>

export const useAbaImportacoes = () => {

    const navigate = useNavigate();

    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const refAbortController = useRef<AbortController>();

    const refsocket = useRef<any>(null);

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<ICongelamentoEmLote>>([]);
    const [visibleModal, setVisibleModal] = useState<boolean>(false);
    const [arquivoObjeto, setArquivoObjeto] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);

    useEffect(() => () => {
        refAbortController.current?.abort();
        desconectarSocker();
    }, []);

    //setando dados das cidades no selected
    const buscaCongelamentosEmLote = useCallback(() => {

        const requestAsync = async () => {
            try {
                setLoadingPage(true);

                const response = await CongelamentoEmLoteService.getCongelamentos(refAbortController.current?.signal);

                setDadosTabelaState(response);

                setLoadingPage(false);

            } catch (error) {
                let msgErro: any = (error as Error);
                setLoadingPage(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi')
                }


            }
        }

        requestAsync();

    }, []);

    useEffect(() => {

        refAbortController.current = new AbortController();

        let arrayUrl = window.location.pathname.split("/");
        VerificaRota(arrayUrl, navigate, true);

        buscaCongelamentosEmLote();

        socketConnection();
    }, []);

    const desconectarSocker = useCallback((): void => {
        //desconectar socket
        if (refsocket.current) {

            refsocket.current.close();
            refsocket.current = null

        }
    }, [])

    const socketConnection = useCallback((): void => {

        const socket = io(urlHttpGovSocketIo);


        refsocket.current = socket
        socket.on('connect', () => {
            socket.emit("solicitacao_congelamento_cnpj_em_lote", "solicitacao_congelamento_cnpj_em_lote");

            socket.on('solicitacao_congelamento_cnpj_em_lote', data => {

                setDadosTabelaState((prevState) => {
                    const currentData = [...prevState];

                    const congelamentoIndex = currentData.findIndex((e) => e.id === data.solicitacaoId);

                    if (congelamentoIndex < 0) {
                        return currentData;
                    }

                    currentData[congelamentoIndex].arquivoResposta = data.arquivoResposta;
                    currentData[congelamentoIndex].status = data.status;

                    return currentData;
                });

            })

        });

    }, []);

    const beforeUpload = useCallback((file: RcFile) => {

        const xlsxMimeTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/wps-office.xlsx',
            'application/vnd.ms-excel',
            'text/csv',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-spreadsheet',

            'application/excel',
            'application/x-excel',
            'application/x-msexcel',
            'application/octet-stream',
        ];
        const isXLSX = xlsxMimeTypes.includes(file.type);

        if (!isXLSX) {
            message.error('Você só pode fazer upload de arquivos XLSX!');
        }

        return isXLSX;
    }, []);

    const handleChange = useCallback((info: UploadChangeParam<UploadFile<any>>) => {

        if (info?.file?.status === 'done') {
            setArquivoObjeto(info)
        }


    }, [arquivoObjeto]);

    const clickCancelModal = useCallback(() => {
        setArquivoObjeto(null);
        setVisibleModal(false);
    }, []);

    const dummyRequest = useCallback(({ file, onSuccess }: any) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    }, []);

    const clickBtnSubmitUploadArquivo = useCallback((arquivo: any) => {

        const buscaXLSX = async () => {
            try {

                setLoading(true)
                const formData = new FormData();

                formData.append("arquivo", arquivo.file.originFileObj);

                await CongelamentoEmLoteService.postCongelamentoEmLote(formData, refAbortController.current?.signal);

                notification.success({
                    message: 'Sucesso',
                    description: "Arquivo enviado com sucesso!",
                });

                clickCancelModal();
                buscaCongelamentosEmLote();
                setLoading(false)

            } catch (error) {
                setLoading(false)
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'relatorioconsolidado_dkwdfaiweyi')
                }


            }
        }


        buscaXLSX();

    }, []);

    const handleClickBaixarResultado = useCallback((isArquivoResultado: boolean, record?: ICongelamentoEmLote) => {

        const requestAsync = async () => {
            try {
                if (!record) {
                    notification.error({
                        message: 'Não foi possível baixar.',
                        description:
                            'Tente novamente mais tarde.',
                    });
                    return
                }

                let filename = ''
                if (isArquivoResultado) {
                    if (!record.arquivoResposta) {
                        notification.error({
                            message: 'Não foi possível baixar.',
                            description:
                                'Tente novamente mais tarde.',
                        });
                        return
                    }

                    filename = record.arquivoResposta
                } else {
                    if (!record.arquivoSolicitacao) {
                        notification.error({
                            message: 'Não foi possível baixar.',
                            description:
                                'Tente novamente mais tarde.',
                        });
                        return
                    }
                    filename = record.arquivoSolicitacao
                }

                setLoading(true);

                const response = await CongelamentoEmLoteService.getCongelamentosArquivo(filename, refAbortController.current?.signal);

                const link = document.createElement('a');
                link.href = response?.signedUrl;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();

                setLoading(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoading(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi')
                }


            }
        }

        requestAsync();
    }, [])

    const columns = [
        {
            title: 'Nome Arquivo',
            dataIndex: 'arquivoSolicitacaoOriginal',
            ...useGetColumnSearchProps('arquivoSolicitacaoOriginal'),
            width: '10%',
            sorter: (a: any, b: any) => a.arquivoSolicitacaoOriginal.localeCompare(b.arquivoSolicitacaoOriginal),
            showSorterTooltip: false,
        },
        {
            title: 'Qtd Registros',
            dataIndex: 'qtdeRegistros',
            ...useGetColumnSearchProps('qtdeRegistros'),
            width: '10%',
            // sorter: (a: any, b: any) => a.qtdeRegistros.localeCompare(b.qtdeRegistros),
            // showSorterTooltip: false,
            render: (qtdeRegistros: any) => {

                if (qtdeRegistros) {

                    return qtdeRegistros
                }
                return
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...useGetColumnSearchPropsObj('usuario'),
            width: '10%',
            sorter: (a: any, b: any) => a.usuario.nome.localeCompare(b.usuario.nome),
            showSorterTooltip: false,
            render: (usuario: any) => {

                return usuario.nome
            },
        },
        // {
        //     title: 'Validade',
        //     dataIndex: 'dataValidade',
        //     ...useGetColumnSearchPropsData('dataValidade'),
        //     width: '2%',
        //     sorter: (a: any, b: any) => {

        //         let aMonMen: any = null
        //         let bMonMen: any = null
        //         if (a.dataValidade) {
        //             aMonMen = moment(a.dataValidade).unix()
        //         } else {
        //             aMonMen = 0
        //         }
        //         if (b.dataValidade) {
        //             bMonMen = moment(b.dataValidade).unix()
        //         } else {
        //             bMonMen = 0
        //         }

        //         return aMonMen - bMonMen
        //     },
        //     showSorterTooltip: false,
        //     // sorter: (a: any, b: any) => a.dataValidade.localeCompare(b.dataValidade),
        //     render: (criado: any, record: any) => {
        //         return (
        //             <div
        //                 style={{
        //                     display: 'flex',
        //                     justifyContent: 'space-between',
        //                     alignItems: 'center'
        //                 }}
        //             >

        //                 <Text>
        //                     {
        //                         criado ? convertDataUSParaBrasil(criado) : '-'
        //                     }
        //                 </Text>

        //                 {/* <img style={{
        //                     width: 20,
        //                     marginLeft: 5
        //                 }} src={record.status ? ImgDownLike : ImgUpLike} /> */}
        //             </div>
        //         )
        //     },
        // },
        {
            title: 'Criado em',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (data: any) => {

                return (
                    convertDataUSParaBrasilEHora(data)
                )
            },
        },
        {
            title: '',
            dataIndex: 'arquivo',
            width: '2%',
            showSorterTooltip: false,
            render: (arquivo: any, record: ICongelamentoEmLote) => {
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        {
                            record?.arquivoSolicitacao && (
                                <Tooltip title="Baixar Excel" color="blue">
                                    <Button
                                        type="primary"
                                        // verde
                                        // className="CertidoesCongelamento_BotaoAzulMarinho_edfrgjkfbrgqrepiujhnbw"
                                        style={{
                                            marginRight: 5
                                        }}
                                        onClick={() => handleClickBaixarResultado(false, record)}
                                    >
                                        <FileExcelOutlined />
                                    </Button>
                                </Tooltip>
                            )
                        }
                        {
                            record.status === "em_andamento" && (
                                <Spin
                                    indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                                    style={{
                                        width: "100%",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        maxWidth: 46,
                                    }}
                                />
                            )
                        }
                        {
                            record?.arquivoResposta && (
                                <Tooltip title="Baixar Resultado" color="#30912d">
                                    <Button
                                        type="primary"
                                        className="CertidoesCongelamento_BotaoVerde_edfrgjkfbrgqrepiujhnbw"
                                        onClick={() => handleClickBaixarResultado(true, record)}
                                    >
                                        <IconDownload />
                                    </Button>
                                </Tooltip>
                            )
                        }

                    </div>
                )
            },
        },
    ];

    return {
        loadingPage,
        setVisibleModal,
        clickBtnSubmitUploadArquivo,
        arquivoObjeto,
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        visibleModal,
        clickCancelModal,
        loading,
        dummyRequest,
        beforeUpload,
        handleChange,
        setArquivoObjeto,
    }
}
